<template>
  <div class="">
    <b-container fluid>
      <b-card>
        <b-row>
          <b-col md="6">
            <b-card-title class="title">
              {{ $t("CUT DAYS") }}
            </b-card-title>

            <b-form-group
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="12"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="12"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #8b869a"
                />
                <span> {{ $t("Payroll Cut Type") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <v-select
                  :clearable="false"
                  v-if="settings.payroll_cut_type"
                  v-model="settings.payroll_cut_type"
                  :placeholder="$t('Select a payroll cut type')"
                  :reduce="(value) => value.id"
                  class="w-100"
                  label="value"
                  :options="payrollCutTypes"
                >
                  <template #selected-option="{ value }">
                    <span class="text-truncate">{{ value }}</span>
                  </template>
                </v-select>
              </b-input-group>
            </b-form-group>

            <b-form-group
              class="mt-3"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="12"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="12"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #8b869a"
                />
                <span> {{ $t("Fornight cut day") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <b-form-input
                  v-model="settings.fornight_cut_day"
                  type="number"
                  min="1"
                  max="31"
                  class="w-100"
                  disabled
                />
              </b-input-group>
            </b-form-group>

            <b-form-group
              class="mt-3"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="12"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="12"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #8b869a"
                />
                <span> {{ $t("Monthly cut day") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <b-badge
                  v-if="settings.monthly_cut_day === -1"
                  variant="info"
                  class="w-100"
                >
                  <h5 class="text-white">{{ $t("Last day of the month") }}</h5>
                </b-badge>

                <b-form-input
                  v-else
                  v-model="settings.monthly_cut_day"
                  type="number"
                  min="1"
                  max="31"
                  class="w-100"
                  disabled
                />
              </b-input-group>
            </b-form-group>
            <!-- y en dia de corte quincena 15 -->
            <!-- cuando es la opcion b poner "ultimo dia del mes" -->
            <!-- validacion a schedules de employees -->

            <!-- <b-form-group
                class="mt-3"
                label-class=" font-weight-normal color-gray-input-sm"
                label-cols-lg="6"
                label-cols-md="12"
                label-cols-sm="6"
                content-cols-lg="6"
                content-cols-md="12"3
                content-cols-sm="6"
              >
                <template #label>
                  <feather-icon
                    icon="SquareIcon"
                    style="margin-right: 0.5rem; fill: #8b869a"
                  />
                  <span> {{ $t("Cut off day") }} </span>
                </template>

                <b-skeleton
                  v-if="!finishedLoading"
                  class="space"
                  type="input"
                />

                <b-input-group v-else>
                  <b-form-input
                    v-model="settings.cut_off_day"
                    type="number"
                    min="1"
                    max="31"
                    class="w-100"
                  />
                </b-input-group>
              </b-form-group> -->
          </b-col>

          <b-col md="6">
            <b-card-title class="mr-2 title">
              {{ $t("RULES TO APPLY") }}
            </b-card-title>

            <b-form-group
              class="py-md-2 py-lg-0"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="8"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="4"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #9681eb"
                />
                <span> {{ $t("Apply rules") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <!-- <b-form-input v-model="settings.apply_rules" class="w-100" /> -->
                <b-form-checkbox
                  switch
                  :value="1"
                  :unchecked-value="0"
                  v-model="settings.apply_rules"
                ></b-form-checkbox>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="settings.apply_rules === 1"
              class="mt-3"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="12"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="12"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #9681eb"
                />
                <span> {{ $t("Limit lats per month") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <b-form-input
                  v-model="settings.limit_lates_per_month"
                  class="w-100"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="settings.apply_rules === 1"
              class="mt-3"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="6"
              label-cols-md="12"
              label-cols-sm="6"
              content-cols-lg="6"
              content-cols-md="12"
              content-cols-sm="6"
            >
              <template #label>
                <feather-icon
                  icon="SquareIcon"
                  style="margin-right: 0.5rem; fill: #9681eb"
                />
                <span> {{ $t("Discount days to apply") }} </span>
              </template>

              <b-skeleton v-if="!finishedLoading" class="space" type="input" />

              <b-input-group v-else>
                <b-form-input
                  v-model="settings.discount_days_to_apply"
                  class="w-100"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group
              class="mt-3"
              label-class=" font-weight-normal color-gray-input-sm"
              label-cols-lg="10"
              label-cols-md="10"
              label-cols-sm="10"
            >
              <b-button
                v-if="finishedLoading"
                variant="outline-primary"
                class="mt-3 d-flex align-items-center justify-content-right"
                :disabled="isBusy"
                @click="updatePayrollGeneralSettings"
              >
                <template v-if="isBusy">
                  <feather-icon icon="LoaderIcon" size="16" class="mr-1" />
                  <span> {{ $t("Saving") }}... </span>
                </template>
                <template v-else>
                  <feather-icon icon="SaveIcon" size="16" class="mr-1" />
                  <span> {{ $t("Save") }} </span>
                </template>
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import GeneralSettingPayrollService from "@/views/settings/views/payroll/components/general/services/general-setting-payroll.service.js";

import { mapGetters } from "vuex";

export default {
  data() {
    return {
      finishedLoading: false,
      isBusy: false,
      payrollCutTypes: [
        {
          id: 1,
          value: "A",
        },
        {
          id: 2,
          value: "B",
        },
      ],
      settings: {
        id: "",
        status: "",
        cut_off_day: "",
        apply_rules: "",
        limit_lates_per_month: "",
        payroll_cut_type: "",
        discount_days_to_apply: "",
        fornight_cut_day: "",
        monthly_cut_day: "",
        fornight_cut_type: "",
        created_by: "",
        updated_by: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },

  async created() {
    await this.getPayrollGeneralSettings();
  },

  watch: {
    "settings.payroll_cut_type": function (val) {
      if (val == "A" || val == 1) {
        this.settings.fornight_cut_day = 10;
        this.settings.monthly_cut_day = 25;
      } else {
        this.settings.fornight_cut_day = 15;
        this.settings.monthly_cut_day = -1;
      }
    },
  },
  methods: {
    async getPayrollGeneralSettings() {
      try {
        this.addPreloader();
        this.isBusy = true;
        this.finishedLoading = false;
        const { data } =
          await GeneralSettingPayrollService.getPayrollGeneralSettings();
        this.settings = data[0];
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
        this.finishedLoading = true;
        this.removePreloader();
      }
    },
    async updatePayrollGeneralSettings() {
      try {
        this.addPreloader();
        this.isBusy = true;

        if (this.settings.apply_rules === 0) {
          this.settings.limit_lates_per_month = 0;
          this.settings.discount_days_to_apply = 0;
        }

        this.settings.updated_by = this.currentUser.user_id;

        await GeneralSettingPayrollService.updatePayrollGeneralSettings(
          this.settings
        );
        this.getPayrollGeneralSettings();
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
        this.removePreloader();
        this.finishedLoading = true;
      }
    },
  },
};
</script>

<style scoped>
.lds-ring {
  animation: lds-ring 0.9s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.active-border {
  border: 1px solid rgb(130, 189, 233);
  border-radius: 0.357rem;
}

.title {
  color: #8b869a;
  font-family: sans-serif;
  font-size: 17px;
}

.color-disabled {
  color: #a2a9b3;
}

.subtitle {
  color: #5e5873;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: bold;
}

.margin-tramo,
.margin-pension {
  margin-top: 10.5px;
}

.space {
  width: 357px;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 769px) {
  /* Estilos para dispositivos con ancho menor a 575px */
  .modal-subtitle {
    display: none;
  }

  .btn-sm-style {
    width: 31.5px 37.28px;
    padding: 6.75px;
    margin-top: 4px;
  }
}

@media (max-width: 575px) {
  /* Estilos para dispositivos con ancho menor a 575px */
  .margin-xs {
    padding-top: 20px;
  }

  .btn-sm-style {
    width: 37.84px 37.28px;
    padding: 9.65px 9.93px;
    margin-top: 4px;
  }
}
</style>
